import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  { path: 'auth', loadChildren: () => import(`./authentication/authentication-routes`).then(mod => mod.routes) },  
  { path: 'flussi', loadChildren: () => import(`./flows/core/flows-routes`).then(mod => mod.routes)}, 
  { path: '', loadChildren: () => import(`./pages/pages-routes`).then(mod => mod.routes) }, 
];